// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FileUploadDialog-components-FileList-module__FullTextLink";
var _2 = "webpack-components-FileUploadDialog-components-FileList-module__LinkWrapper";
export { _1 as "FullTextLink", _2 as "LinkWrapper" }
